export const getNotificationMessage = (notification) => {
  switch (notification.type) {
    case 'manual':
      return notification.message;

    case 'control_point_request_created':
      return `Создан запрос на изменение контрольной точки "${notification.control_point.name}"`;

    case 'critical_control_point_closure_requested':
      return `Создан запрос на закрытие критической контрольной точки "${notification.control_point.name}"`;

    case 'control_point_request_resolved':
      let message = `Запрос на изменение контрольной точки "${notification.control_point.name}"`;
      if (notification.control_point_request.status === 'approved') return `${message} одобрен`;
      return `${message} отклонен`;

    case 'critical_control_point_closure_resolved':
      let result = `Запрос на закрытие критической контрольной точки "${notification.control_point.name}"`;
      if (notification.control_point_request.status === 'approved') {
        result = `${result} одобрен`;
      } else {
        result = `${result} отклонен`;
      }
      if (notification.message && notification.message.length > 0) {
        result = `${result}. Комментарий модератора: "${notification.message}"`
      }
      return result;

    case 'control_point_deadline_approaching':
      return `Истекает срок исполнения контрольной точки "${notification.control_point.name}"`;

    case 'project_completed':
      return `Проект "${notification.project.name}" выполнен на 100%`;

    default:
      return '';
  }
};

export default {
  getNotificationMessage
};
